/*
  GEMDRAW — Cart entry attribution

  Keeps the cart's entry figure in step with the cart itself, by asking the
  integration adapter after every cart update.

  This file contains no arithmetic. It does not add line values together, it
  does not multiply anything by a quantity or a price, and it has no fallback
  number. If the adapter cannot answer, the cart says so.

  The theme's own cart and cart drawer behavior is untouched: this only listens
  to the update event the theme already publishes.
*/

(function () {
  'use strict';

  function strings() {
    return window.gemdrawStrings || {};
  }

  function render(result) {
    const nodes = document.querySelectorAll('[data-gd-cart-entries-value]');
    if (!nodes.length) return;

    const copy = strings();
    const available = result && result.status === 'ok' && result.value !== null;

    nodes.forEach(function (node) {
      node.textContent = '';
      node.classList.toggle('gd-cart-entries__value--unavailable', !available);

      if (available) {
        node.appendChild(document.createTextNode(String(result.value)));

        /* A mirrored display value is not the authoritative figure, and the
           cart has to say which one the visitor is looking at. */
        if (result.authoritative === false && copy.entriesDisplayOnly) {
          const note = document.createElement('span');
          note.className = 'gd-cart-entries__note';
          note.textContent = copy.entriesDisplayOnly;
          node.appendChild(note);
        }
        return;
      }

      node.appendChild(document.createTextNode(copy.entriesUnavailable || ''));

      if (copy.cartEntryNote) {
        const note = document.createElement('span');
        note.className = 'gd-cart-entries__note';
        note.textContent = copy.cartEntryNote;
        node.appendChild(note);
      }
    });
  }

  function refresh() {
    if (!window.GemdrawAdapter) return;

    window.GemdrawAdapter.getCartTotalEntries()
      .then(render)
      .catch(function () {
        render(null);
      });
  }

  function start() {
    refresh();

    /* The theme publishes this after every successful cart mutation. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }

    /* The drawer re-renders its own markup, so pick the new nodes up too. */
    document.addEventListener('shopify:section:load', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
